import { render, staticRenderFns } from "./agenda_form.vue?vue&type=template&id=d339496e&"
import script from "./agenda_form.vue?vue&type=script&lang=js&"
export * from "./agenda_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports